export const timesheetColumns = [
  {
    name: 'id',
    options: {
      display: false,
      filter: false,
    },
  },
  {
    name: 'provider_name', // This column will be displayed to admin and cofig will be updated conditionally
    label: 'Provider',
    options: {
      filter: false,
      sort: false,
      display: false,
      filterOptions: {
        fullWidth: true,
      },
    },
  },
  {
    name: 'client_name',
    label: 'Client name',
    options: {
      filter: true,
      sort: true,
      filterOptions: {
        fullWidth: true,
      },
    },
  },
  {
    name: 'service_code',
    label: 'Type',
    options: {
      filter: true,
      sort: true,
      filterOptions: {
        fullWidth: true,
      },
    },
  },
  {
    name: 'date_start',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'date_start',
    label: 'Start',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'date_end',
    label: 'End',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'duration',
    label: 'Duration',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'label',
    label: 'Description',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'client_id',
    options: {
      display: false,
      filter: false,
    },
  },
  {
    name: 'service_code_id',
    options: {
      display: false,
      filter: false,
    },
  },
  {
    name: 'utc_offset',
    options: {
      display: false,
      filter: false,
    },
  },
  {
    name: 'read_only',
    options: {
      display: false,
      filter: false,
    },
  },
  {
    name: 'pay_period',
    options: {
      display: false,
      filter: false,
    },
  },
];

export enum timesheetFilter {
  Bt = 'bt',
  Client = 'client',
  Type = 'type',
}
